export default "__VITE_ASSET__Bw_JnvGy__"